import React from 'react'
import {
    Box,
    Flex,
    Heading,
    Icon,
    Popover,
    PopoverContent,
    PopoverTrigger,
    SimpleGrid,
    Stack,
    useColorModeValue,
} from '@chakra-ui/react'
import MenuItem from './menuItem'
import { ChevronRightIcon } from '@chakra-ui/icons'

const MegaMenu = ({ menu }) => {
    const popoverContentBgColor = useColorModeValue('white', 'gray.800')
    const btnColor = useColorModeValue('brand.blue', 'brand.yellow')
    const popoverBorderColor = useColorModeValue('brand.blue', 'brand.yellow')

    return (
        <Popover trigger={'hover'} key={menu.id} variant="responsive" m={0}>
            {/*<Popover key={menu.id} variant="responsive" m={0}>*/}
            <PopoverTrigger>
                <Box
                    px={[1, 1, 1, 1, 2, 4]}
                    py={'6px'}
                    fontWeight={600}
                    color={'#fff'}
                    textTransform={'uppercase'}
                    _hover={{
                        textDecoration: 'none',
                        cursor: 'pointer',
                    }}
                    fontSize={['11px', '12px', '13px','13px', '15px', '16px']}
                >
                    <MenuItem menu={menu}>{menu.title}</MenuItem>
                </Box>
            </PopoverTrigger>
            {menu?.subItems && (
                <PopoverContent
                    padding={6}
                    borderWidth={2}
                    borderColor={popoverBorderColor}
                    bg={popoverContentBgColor}
                    rounded={'3xl'}
                    minW={'calc(100vw - 10px)'}
                    maxH={'90vh'}
                    left={'-5px'}
                    overflowY="scroll"
                >
                    <SimpleGrid columns={[5]} spacing={4} p={2}>
                        {menu.subItems.map((child) => (
                            <DesktopSubNav key={child.id} {...child} />
                        ))}
                    </SimpleGrid>
                </PopoverContent>
            )}
        </Popover>
    )
}

const DesktopSubNav = (menu) => {
    const popoverItemBorderHoverColor = useColorModeValue('brand.blue', 'brand.yellow')
    const popoverItemBgColor = useColorModeValue('gray.100', 'gray.900')
    const popoverItemBgHoverColor = useColorModeValue('gray.200', 'gray.900')

    return (
        <Stack direction={'column'} align={'start'}>
            <Box
                role={'group'}
                display={'block'}
                px={2}
                py={2}
                m={0}
                rounded={'md'}
                _hover={{ bg: popoverItemBgColor }}
            >
                <Heading
                    fontSize={'18px'}
                    transition={'all .3s ease'}
                    color={useColorModeValue('brand.blue', 'brand.yellow')}
                    _groupHover={{ color: 'gray.700' }}
                    fontWeight={800}
                >
                    <MenuItem menu={menu}>{menu.title}</MenuItem>
                </Heading>
            </Box>

            {menu?.subItems?.map((item) => (
                <Box
                    key={item.title}
                    display={'block'}
                    width={'100%'}
                    role={'group'}
                    rounded={'md'}
                    bgColor={popoverItemBgColor}
                    borderWidth={2}
                    _hover={{ bg: popoverItemBgHoverColor, borderColor: popoverItemBorderHoverColor }}
                    fontSize={15}
                    fontWeight={'bold'}
                >
                    <Stack direction={'row'} align={'center'} width={'100%'}>
                        <Box display={'block'} width={'100%'}>
                            <MenuItem menu={item}>
                                <Box p={2} width={'100%'}>
                                    {item.title}
                                </Box>
                            </MenuItem>
                        </Box>
                        <Flex
                            transition={'all .3s ease'}
                            transform={'translateX(-10px)'}
                            opacity={1}
                            _groupHover={{ opacity: '100%', transform: 'translateX(0px)' }}
                            justify={'flex-end'}
                            align={'center'}
                            flex={1}
                        >
                            <Icon color={'brand.blue'} w={5} h={5} as={ChevronRightIcon} />
                        </Flex>
                    </Stack>
                </Box>
            ))}
        </Stack>
    )
}

export default MegaMenu
